<template>
    <section id="container">
        <section id="user-visual" class="mypage">
            <div class="grid--con">
                <div class="user-visual-txt">자료실<!--<span> 궁금한 점이 있으신가요? 고객센터에서 해결 방법을 찾아보세요.</span>--></div>
            </div>
        </section>
        <section id="lnb">
            <div class="grid--lnb">
                <div class="grid--con">
                    <div class="pt-lnb">
                        <ul>
                            <li v-for="(cdInfo, index) in nclCdList"
                                :key="'nclCd_'+index"
                                :class="selNclCd == cdInfo.cd ? 'current':''"
                                @click="tabClick(cdInfo.cd)">
                                <a href="javascript:;">{{cdInfo.cdNm}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <div id="content" class="sub">
            <div class="grid--con-sub">
                <template v-if="mode=='list'">
                    <div class="tab-faq">
                        <div class="tab-container">
                            <div class="tab-content" id="tab-1" style="display:;">
                                <div class="board-number-cases mgt10"></div>
                                <div class="board-list mgt10">
                                    <template v-if="list.imprtnCloudList.length > 0 || list.cloudList.length > 0">
                                    <li v-for="(info, index) in list.imprtnCloudList" :key="'info_'+index" @click="showCloudView(info)">
                                        <a href="javascript:;">
                                            <div class="board-tit-con">
                                                <div class="entry-tag">
                                                    <span class="tag02">중요</span>
                                                </div>
                                                <div class="entry-title">{{info.sj}}</div>
                                                <div class="entry-date">{{info.creatDt}}</div>
                                            </div>
                                        </a>
                                    </li>
                                    <li v-for="(cloudInfo, index) in list.cloudList" :key="'cloudInfo'+index" @click="showCloudView(cloudInfo)">
                                        <a href="javascript:;">
                                            <div class="board-tit-con">
                                                <div class="entry-title">{{cloudInfo.sj}}</div>
                                                <div class="entry-date">{{cloudInfo.creatDt}}</div>
                                            </div>
                                        </a>
                                    </li>
                                    </template>
                                    <template v-if="list.imprtnCloudList.length == 0 && list.cloudList.length == 0">
                                        <li>
                                            <a href="javascript:;">
                                                <div class="board-tit-con">
                                                    <div class="entry-title">등록된 자료가 없습니다.</div>
                                                </div>
                                            </a></li>
                                    </template>
                                </div>
                                <pagenavi :paginginfo="paginginfo" v-if="paginginfo.totCnt > paginginfo.pageListCnt"></pagenavi>
                            </div>
                        </div>
                    </div>
                </template>

                <template v-if="mode=='view'">
                    <div class="board-view box-type04">
                        <div class="section-title">
                            <div class="board-tit-con">
                                <div class="entry-tag" v-if="view.cloudInfo.clCd == '999'">
                                    <span class="tag02">중요</span>
                                </div>
                                <div class="entry-title">{{view.cloudInfo.sj}}</div>
                                <div class="entry-date">{{view.cloudInfo.creatDt}}</div>
                            </div>
                        </div>
                        <div class="board-view-con" v-html="view.cloudInfo.cn"></div>
                        <div class="board-view-bt-box">
                            <div class="board-view-bt">
                                <div class="entry-title"><div class="img-com __icon04"><span>첨부파일 아이콘</span></div>첨부파일</div>
                                <div class="entry-con">
                                    <div class="file-att-list">
                                        <ul>
                                            <li v-for="(fileInfo, index) in view.cloudInfo.fileList" :key="'fileInfo_'+index">
                                                <a href="javascript:;" @click="downloadFile(fileInfo)">
                                                    <div class="img-com" :class="$onbiLib.bindFileIconClass(fileInfo.extsn)"><span>bmp</span></div>{{fileInfo.orginlNm}}
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="btn-wrap f-oh __right mgt30">
                        <button class="middle _bt-ypurple" @click="showCloudList()"><span>목록으로</span></button>
                    </div>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
    const mixinView = {
        data: function () {
            return {
                view: {
                    cloudInfo : null,
                },
            }
        },
        methods : {
            showCloudList : function(){
                this.mode = 'list';
                this.searchCloudList();
                window.scrollTo(0, 0);
            },
            downloadFile : function(fileInfo){
                const _this = this;
                if(this.$onbiLib.chkCdnAt(fileInfo)){
                    _this.$onbiLib.getAuthKey().then(function(authKey){
                        _this.$onbiLib.setCdnFileDownLoadUrl(fileInfo,encodeURIComponent(authKey));
                    });
                }else{
                    const param = 'sn='+this.view.cloudInfo.sn+'&fgrpCd='+fileInfo.fgrpCd+'&fileCd='+fileInfo.fileCd+'&srvcCd='+this.view.cloudInfo.srvcCd;
                    this.$onbiLib.setFileDownLoadUrl('/admin/notice/noticeFileDownLoad.act', param);
                }

            }
        },
    }

    const mixinList = {
        data : function(){
            return {
                list : {
                    cloudList : new Array(),
                    imprtnCloudList : new Array(),
                    listCntMsg : '',
                },
                paginginfo: {
                    totCnt: 0, /* 총게시물 수*/
                    pageListCnt: 15, /* 페이지당 게시물수 */
                    pageCnt: 10, /* 페이지당 게시물수 */
                    curPageNum: 1,/* 현재페이지 */
                    callBackFunc:null
                },
            }
        },
        methods : {
            showCloudView : function(info){
              if(!this.loginAt){
                alert('로그인이 필요합니다.');
                return;
              }

                const _this = this;

                this.axios.post('/i5gam/cs/notice/searchNoticeDetailInfo.act',{
                    sn : info.sn,
                    srvcCd : this.srvcCd
                }).then(function(response) {
                    this.mode = 'view';
                    const cloudInfo = response.data.ntcInfo;
                    console.log(cloudInfo);
                    this.view.cloudInfo = cloudInfo.ntcDetailInfo;
                    this.view.cloudInfo.fileList = cloudInfo.ntcFileList;
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
                window.scrollTo(0, 0);
            }
        }
    }

    export default {
        name : 'cloud',
        mixins : [mixinList, mixinView],
        data : function(){
            return {
                mode : 'list',
                nclCdList : new Array(),
                srvcCd : 'SBIW02',
                selNclCd : '',
            }
        },
        computed: {
          loginAt : function(){
            return this.$store.getters.getLoginAt;
          },
        },
        methods : {
            init : function(){
                this.paginginfo.callBackFunc = this.searchCloudList;
                this.mode = 'list';

                this.$nextTick(function(){
                    this.searchCloudList();
                })
            },
            searchCloudList : function(){

                const _this = this;
                this.axios.post('/i5gam/cs/searchCloudList.act',{
                    pagingInfo : {
                        curPageNum : this.paginginfo.curPageNum,
                        startCnt : ((this.paginginfo.curPageNum-1) * this.paginginfo.pageListCnt)+1,
                        endCnt : this.paginginfo.curPageNum * this.paginginfo.pageListCnt,
                        srvcCd : this.srvcCd,
                        nclCd : this.selNclCd
                    },
                }).then(function(response) {
                    const cloudInfo = response.data.cloudInfo;
                    
                    this.list.cloudList = cloudInfo.cloudList;
                    this.list.imprtnCloudList = cloudInfo.imprtnCloudList;
                    this.paginginfo.totCnt = cloudInfo.pagingInfo.totCnt;
                    this.paginginfo.curPageNum = cloudInfo.pagingInfo.curPageNum;

                    window.scrollTo(0, 0);
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                    window.scrollTo(0, 0);
                });
            },
            tabClick : function(cd){
                this.selNclCd = cd;

                this.mode = 'list';
                this.searchCloudList();
            },
        },
        mounted : function(){
            const _this = this;
            const searchInfo = {cdGrp : 'CLD'};
            this.$onbiLib.searchCmmnCodeList(searchInfo).then(function(codeInfo){
                _this.nclCdList = codeInfo;
                _this.selNclCd = _this.nclCdList[0].cd;
                _this.init();
            });
        }
    }
</script>